/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CRSFSecReviewWTechsAggregatedRecord
 */
export interface CRSFSecReviewWTechsAggregatedRecord {
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewWTechsAggregatedRecord
     */
    asset: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewWTechsAggregatedRecord
     */
    category: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewWTechsAggregatedRecord
     */
    created: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof CRSFSecReviewWTechsAggregatedRecord
     */
    cves: Array<string>;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof CRSFSecReviewWTechsAggregatedRecord
     */
    data: { [key: string]: any; };
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewWTechsAggregatedRecord
     */
    found: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewWTechsAggregatedRecord
     */
    module: string;
    /**
     * 
     * @type {number}
     * @memberof CRSFSecReviewWTechsAggregatedRecord
     */
    port: number;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewWTechsAggregatedRecord
     */
    process_id: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewWTechsAggregatedRecord
     */
    protocol: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewWTechsAggregatedRecord
     */
    se_version?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CRSFSecReviewWTechsAggregatedRecord
     */
    shared: boolean;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewWTechsAggregatedRecord
     */
    source: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewWTechsAggregatedRecord
     */
    source_asset: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewWTechsAggregatedRecord
     */
    tech_key: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewWTechsAggregatedRecord
     */
    tech_name: string;
    /**
     * 
     * @type {string}
     * @memberof CRSFSecReviewWTechsAggregatedRecord
     */
    version: string;
}

/**
 * Check if a given object implements the CRSFSecReviewWTechsAggregatedRecord interface.
 */
export function instanceOfCRSFSecReviewWTechsAggregatedRecord(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "asset" in value;
    isInstance = isInstance && "category" in value;
    isInstance = isInstance && "created" in value;
    isInstance = isInstance && "cves" in value;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "found" in value;
    isInstance = isInstance && "module" in value;
    isInstance = isInstance && "port" in value;
    isInstance = isInstance && "process_id" in value;
    isInstance = isInstance && "protocol" in value;
    isInstance = isInstance && "shared" in value;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "source_asset" in value;
    isInstance = isInstance && "tech_key" in value;
    isInstance = isInstance && "tech_name" in value;
    isInstance = isInstance && "version" in value;

    return isInstance;
}

export function CRSFSecReviewWTechsAggregatedRecordFromJSON(json: any): CRSFSecReviewWTechsAggregatedRecord {
    return CRSFSecReviewWTechsAggregatedRecordFromJSONTyped(json, false);
}

export function CRSFSecReviewWTechsAggregatedRecordFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFSecReviewWTechsAggregatedRecord {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'asset': json['asset'],
        'category': json['category'],
        'created': json['created'],
        'cves': json['cves'],
        'data': json['data'],
        'found': json['found'],
        'module': json['module'],
        'port': json['port'],
        'process_id': json['process_id'],
        'protocol': json['protocol'],
        'se_version': !exists(json, 'se_version') ? undefined : json['se_version'],
        'shared': json['shared'],
        'source': json['source'],
        'source_asset': json['source_asset'],
        'tech_key': json['tech_key'],
        'tech_name': json['tech_name'],
        'version': json['version'],
    };
}

export function CRSFSecReviewWTechsAggregatedRecordToJSON(value?: CRSFSecReviewWTechsAggregatedRecord | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'asset': value.asset,
        'category': value.category,
        'created': value.created,
        'cves': value.cves,
        'data': value.data,
        'found': value.found,
        'module': value.module,
        'port': value.port,
        'process_id': value.process_id,
        'protocol': value.protocol,
        'se_version': value.se_version,
        'shared': value.shared,
        'source': value.source,
        'source_asset': value.source_asset,
        'tech_key': value.tech_key,
        'tech_name': value.tech_name,
        'version': value.version,
    };
}

